import { type WidgetMetadata } from '@examdojo/core/widget';
import { ARITHMETIC_SERIES_EXPLORATION_PRESET } from './presets';
import { ArithmeticSeriesWidgetConfig } from './arithmetic-series.model';

/**
 * Metadata for the Arithmetic Series Widget.
 * Visualizes Sₙ = u₁ + u₂ + ... + uₙ with interactive hover.
 */
export const ARITHMETIC_SERIES_METADATA: WidgetMetadata<ArithmeticSeriesWidgetConfig> = {
  type: 'arithmetic-series',
  description: 'Interactive arithmetic series visualization showing cumulative sum Sₙ',

  parameters: ['a', 'd', 'numTerms'],

  displayFeatures: ['sumLine', 'bars', 'points', 'termLabels', 'sumTooltip', 'grid', 'axes'],

  supportedActions: ['UPDATE_PARAMS', 'FIT_TO_SERIES', 'HIGHLIGHT_SUM', 'FOCUS_REGION', 'RESET_VIEW'],

  focusableRegions: ['all', 'series'],

  highlightableObjects: ['sum-line', 'bar-1', 'bar-2', 'bar-3', 'sum-point-1', 'sum-point-2', 'sum-point-3'],

  exampleConfigs: [ARITHMETIC_SERIES_EXPLORATION_PRESET.config],
};
